var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigcoming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 226,
    viewBox: "0 0 227 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 113,
    r: 113,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.416 97.2109C101.416 97.2109 103.739 105.122 107.003 108.379C110.266 111.636 115.692 116.902 116.805 121.686",
    stroke: "#D0D6D5",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.415 94.7084C101.415 94.7084 105.167 95.7838 100.513 97.3289C95.8589 98.874 100.191 94.9123 100.191 94.9123C100.191 94.9123 90.7415 95.8456 84.1964 86.5069C77.6513 77.1683 85.0679 69.3191 89.0852 67.4835C93.1025 65.6479 102.608 65.4748 106.798 73.8555C110.989 82.2362 105.55 92.1806 101.415 94.7084Z",
    fill: "#FFAF21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0852 67.4834C85.0679 69.3189 77.6513 77.1681 84.1964 86.5068C85.7205 88.6813 87.4021 90.299 89.0852 91.5011C87.3901 86.8094 86 75.2335 94 66.4629C92.0546 66.5164 90.3134 66.9222 89.0852 67.4834Z",
    fill: "url(#paint0_linear_32346_435015)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.07 125.533C132.07 125.533 130.735 119.933 125.908 119.581C121.081 119.229 119.938 122.047 119.938 122.047C119.938 122.047 117.237 118.227 111.712 119.111L120.482 126.67L132.07 125.533Z",
    fill: "#FFAF21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.786 186.651L71.0446 194L63.8691 150.495L128.64 143.141L136.786 186.651Z",
    fill: "#FFAF21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.47 187.358L136.786 186.652C134.629 186.965 132.524 187.198 130.47 187.358L71.0446 194L63.8691 150.496C69.1698 164.557 89.7069 190.526 130.47 187.358Z",
    fill: "url(#paint1_linear_32346_435015)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.741 180.019L136.786 186.65L128.64 143.14L144.023 136.459L150.741 180.019Z",
    fill: "#FFAF21"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.741 180.019L136.786 186.65L128.64 143.14L144.023 136.459L150.741 180.019Z",
    fill: "#141C1A"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.786 186.65L150.742 180.019L144.023 136.459C145.206 148.573 145.415 175.571 136.786 186.65Z",
    fill: "url(#paint2_linear_32346_435015)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64 143.14L60 150.934L63.8381 132.553L124.919 126.156L128.64 143.14Z",
    fill: "#FFAF21"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64 143.14L60 150.934L63.8381 132.553L124.919 126.156L128.64 143.14Z",
    fill: "#141C1A"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64 143.14L146.322 135.464L139.573 124.877L124.919 126.156L128.64 143.14Z",
    fill: "#FFAF21"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.919 93.4676C124.919 93.4676 123.281 101.496 121.891 104.753C120.5 108.01 118.096 116.199 119.938 122.052C119.938 122.052 113.288 114.759 113.288 105.569C113.288 96.3786 114.011 82.1574 110.204 69.2402",
    stroke: "#D0D6D5",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.92 90.6126C124.92 90.6126 122.596 91.7745 122.769 92.2999C122.942 92.8252 126.082 93.6966 127.132 93.1157C128.183 92.5347 126.143 90.6126 126.143 90.6126C126.143 90.6126 139.87 89.4754 140.828 76.651C141.786 63.8265 131.922 61.1196 126.953 61.8179C123.986 61.8179 113.344 66.3543 114.042 76.3914C114.741 86.4284 124.92 90.6126 124.92 90.6126Z",
    fill: "#3D7DFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.042 76.3914C113.344 66.3543 123.986 61.8179 126.953 61.8179C130.278 61.3507 135.793 62.4078 138.793 66.9993C127.027 64.5993 117.39 72.2607 114.042 76.3914Z",
    fill: "url(#paint3_linear_32346_435015)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.86 67.3189C111.86 67.3189 114.481 69.1483 113.517 70.199C112.553 71.2497 109.246 70.7244 109.11 69.8529C108.974 68.9815 110.896 67.3251 110.896 67.3251C110.896 67.3251 98.7009 65.721 96 51.4998C93.2991 37.2785 107.41 32.591 112.12 33.0298C115.946 33.3821 124.944 37.0409 125.383 48.3882C125.822 59.7355 116.57 66.1014 111.86 67.3251V67.3189Z",
    fill: "#DF002C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.12 33.0298C107.411 32.591 93.2993 37.2785 96.0001 51.4998C97.0262 56.9026 99.4227 60.4843 102 62.8489C99.8335 54.9534 99.9001 38.2962 117.5 34.8311C115.465 33.6903 113.47 33.1541 112.12 33.0298Z",
    fill: "url(#paint4_linear_32346_435015)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.476 126.67C120.476 126.67 121.977 134.285 127.286 136.967C132.595 139.649 136.433 136.979 139.691 143.957C142.948 150.935 142.132 154.081 150.043 154.192C157.954 154.303 164.122 159.544 166.1 163.382L160.166 170.249C160.166 170.249 155.976 163.382 150.741 163.036C145.506 162.69 140.154 161.522 136.78 155.008C133.405 148.493 134.141 144.903 131.192 143.141C128.244 141.38 121.539 140.7 119.79 135.694C118.04 130.688 120.469 126.664 120.469 126.664L120.476 126.67Z",
    fill: "#DF002C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.167 170.249L166.1 163.382C162.699 158.764 154.5 160 148.5 160C143.7 160 138.687 156.672 136.78 155.008C140.154 161.522 145.507 162.69 150.741 163.036C155.976 163.382 160.167 170.249 160.167 170.249Z",
    fill: "url(#paint5_linear_32346_435015)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.189 137.38C127.893 137.258 127.592 137.121 127.287 136.967C127.565 137.085 127.868 137.223 128.189 137.38C133.035 139.374 136.621 137.381 139.691 143.957C142.948 150.935 142.132 154.08 150.043 154.192C145.086 154.192 136.78 153 136.78 147C136.78 142.622 131.516 139.002 128.189 137.38Z",
    fill: "url(#paint6_linear_32346_435015)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M136.786 159.661L132.929 166.04C132.929 166.04 114.048 160.113 111.279 145.113C108.51 130.113 114.679 127.202 114.679 127.202L120.476 126.664C120.476 126.664 117.534 130.966 119.166 141.157C120.797 151.349 130 157.758 136.78 159.655L136.786 159.661Z",
    fill: "#DF002C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.476 126.664L114.678 127.202C114.229 129.906 114.498 136.483 119.165 141.157C117.534 130.966 120.476 126.664 120.476 126.664Z",
    fill: "url(#paint7_linear_32346_435015)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132.929 166.038L136.786 159.66L136.78 159.654C123.004 161.778 114.039 150.844 111.279 145.111C114.048 160.111 132.929 166.038 132.929 166.038Z",
    fill: "url(#paint8_linear_32346_435015)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111C80.4649 112.065 80.9984 112.747 81.75 114.25",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M144 198C144.06 195.58 146.5 196.47 146.5 194",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.295 110.791C169.825 111.41 169.29 111.779 169.545 112.541",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151 42.25C151.508 41.5522 152 41.0859 152 40.25C152 39.8074 151.848 39.2012 152.25 39",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.248 148.934C36.0783 148.238 35.9007 147.51 35.248 147.184",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.014 128.134C106.014 128.134 103.572 123.653 108.628 120.161C113.684 116.669 119.215 122.893 119.215 122.893C119.215 122.893 121.248 119.636 125.321 120.569C129.394 121.503 129.209 125.779 129.209 125.779L106.007 128.134H106.014Z",
    fill: "#DF002C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32346_435015",
    x1: 80.6056,
    y1: 75.6975,
    x2: 90.0806,
    y2: 78.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32346_435015",
    x1: 77,
    y1: 206,
    x2: 91.7572,
    y2: 178.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32346_435015",
    x1: 164.5,
    y1: 178.999,
    x2: 142.5,
    y2: 171.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32346_435015",
    x1: 121.5,
    y1: 61.9993,
    x2: 124.5,
    y2: 68.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32346_435015",
    x1: 92,
    y1: 45.4998,
    x2: 104.097,
    y2: 51.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32346_435015",
    x1: 164.5,
    y1: 142,
    x2: 148.265,
    y2: 164.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32346_435015",
    x1: 146.693,
    y1: 115.846,
    x2: 148.388,
    y2: 153.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32346_435015",
    x1: 120.151,
    y1: 114.295,
    x2: 108.41,
    y2: 118.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32346_435015",
    x1: 180,
    y1: 168.499,
    x2: 127.947,
    y2: 119.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcoming);
export default __webpack_public_path__ + "static/media/bigcoming.4864a44e7584d4128ebb059e9b3e1ae0.svg";
export { ForwardRef as ReactComponent };